// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VPFy","controls":"styles_controls__1Zaxy","charLimit":"styles_charLimit__mlYXV","input":"styles_input__mXX6I","send":"styles_send__1keWe"};